<template>
  <RequestsBase type="change"/>
</template>

<script>
import RequestsBase from '@/pages/Requests/RequestsBase.vue';

export default {
  components: {
    RequestsBase,
  },
};
</script>
